<div class="git-actions-menu dropdown-relative dropdown -overflow-in-view dropdown-anchor-right">
  <h3 class="title">{{text.title}}</h3>

  @for (snippet of snippets; track snippet) {
    <div class="copy-wrapper spot-form-field">
      <label class="spot-form-field--label-wrap">
        <div class="spot-form-field--label">{{ snippet.name }}</div>
        <div class="spot-form-field--input">
          <input type="text" class="copy-content op-input" readonly="true" [value]="snippet.textToDisplay()">
          <button
            class="button copy-button"
            type="button"
            [attr.aria-label]="text.copyButtonHelpText"
            (click)="onCopyButtonClick(snippet)"
          >
            <svg copy-icon size="small"></svg>
          </button>
          @if (showCopyResult && snippet.id === copiedSnippetId) {
            <div class="copy-result-message" [textContent]="lastCopyResult"></div>
          }
        </div>
      </label>
    </div>
  }
</div>
